export default {
    visible: false,
    text:'',
    color:'',
    time:-1
}